import { modelSerializer, ModelSerializer } from '@housekeep/infra';

import { workerExtraJobEligibility, WorkerExtraJobEligibility } from 'models/worker-extra-job-eligibility';

export const workerExtraJobEligibilitySerializer = modelSerializer.extend({
  model: workerExtraJobEligibility
}) as ModelSerializer<WorkerExtraJobEligibility>;
